module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-Bold.222586f4.otf";